import {observable} from "mobx";
import {Promise} from "axios";
import mdAxios, {uploadAxios} from "../../core/common/config/axios-config";
import {Project} from "../domain/project/projectDomain";
import {IDomainObject} from "../../core/form/formUtils";
import {ProjectVersion} from "../domain/project/projectVersionDomain";
import {ProjectCriterionVersion} from "../domain/project/projectCriterionVersionDomain";

class ProjectService {
  @observable public projectObject: Project;

  readProject(projectId: number): Promise<Project> {
    return mdAxios.get('sbtool/project/' + projectId)
      .then(response => new Project(response.data));
  }

  saveProject(project: Project): Promise<IDomainObject> {
    return mdAxios.post('/sbtool/project', project)
      .then((response) => response.data);
  }

  deleteProject(projectId : number): Promise<IDomainObject> {
    return mdAxios.delete('/sbtool/project/' + projectId)
      .then((response) => response.data);
  }
  getProjectVersions(projectId: number): Promise<any> {
    return mdAxios.get('sbtool/project/' + projectId + '/versions')
      .then(response => response.data);
  }
  uploadProjectImage(projectId: number, data): Promise<any> {
    return uploadAxios.post(`/sbtool/project/${projectId}/image`, data, {showPrettyError: true})
      .then(res=> res)
  }
  getProjectImage(projectId: number): Promise<any> {
    return mdAxios.get('/sbtool/project/image/' + projectId)
      .then((response) => response.data);
  }
  getVersionsScore(projectId: number): Promise<any> {
    return mdAxios.get(`/sbtool/project/${projectId}/score`)
      .then((response) => response.data);
  }
}

export default new ProjectService();



// WEBPACK FOOTER //
// ./src/sbtool/service/projectService.ts